import commonConfig from "./common";
import arabicLang from './arabic';

let productionConfig = {
  ...commonConfig,
  langLabels: arabicLang
}

export default productionConfig;